jQuery(function($) {

    /*$('section.media-grid-widget .media-grid img').click(function () {

        const spinner = '<div class="vet-spinner vet-spinner--medium loaded"></div>';

        //AJAX call to load pop-up
        let image_id   = $(this).data('id');

        let ajaxurl     = pop_up_data.ajax_url;
        let nonce       = pop_up_data.pop_up_nonce;

        let data = {
            action:     'gallery_pop_up',
            image_id:   image_id,
            security:   nonce
        };

        let gallery         = $('.pop-up-gallery');
        let gallery_inner   = $('.pop-up-gallery .pop-up-gallery__inner');

        gallery_inner.empty();
        gallery_inner.append(spinner);

        gallery.show();

        // Prevent scrolling js
        //const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
        //const body = document.body;
        //const bodyW = $(body).width();

        body.style.position = 'fixed';
        body.style.top = `-${scrollY}`;


        $('body').css('width', bodyW);
        $('body').addClass('vet-gallery-pop-up-open');

        $.ajax({
            type: 'post',
            url: ajaxurl,
            data: data,
            success: function (response) {

                if (response.error & response.product_url) {
                    window.location = response.product_url;
                    return false;
                } else {
                    gallery_inner.empty();

                    gallery_inner.append(response).find('.close').on( 'click', function () {
                        gallery.hide();
                        $('body').removeClass('vet-gallery-pop-up-open');

                        // Prevent scrolling js
                        /*const body = document.body;
                        const scrollY = body.style.top;
                        body.style.position = '';
                        body.style.top = '';
                        window.scrollTo(0, parseInt(scrollY || '0') * -1);*/

                        /*$(body).css('width', '');
                    });
                }
            },
        });

        return false;

    });*/
});

// Prevent scrolling js
/*window.addEventListener('scroll', () => {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
});*/